import React, { useState, useEffect, useRef } from "react";
import { Autocomplete, useLoadScript } from '@react-google-maps/api';
import { TextField, } from "@mui/material";
import { RequestBookingService } from '../../services/RequestBookingService'
import { AppContext } from '../../services/AppContext'
import { handleAutocompletePlaceService } from "../../services/handleAutocompletePlaceService"
import { getTerminalT1Address, getTerminalT2Address } from "../../services/savedAddress"
import MenuIcon from '@mui/icons-material/Menu';
import { getCompactAddress } from "../components/common/utils"
import "../../../styles/SelectSourceAndDestination.css";

//const googleApi = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
const googleApi = "AIzaSyC-vagKdGDTclItg8HzxXIGw_8NlVo6NOc"
const libraries: ("places")[] = ["places"];

interface SelectSourceAndDestinationProps {
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedRoute: string
  isReturn: boolean
  isAutoFill: boolean
}

const SelectSourceAndDestination: React.FC<SelectSourceAndDestinationProps> = ({ handleInputChange, selectedRoute, isReturn, isAutoFill }) => {

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleApi,
    libraries: libraries
  });

  const [source, setSource] = useState<string>(RequestBookingService.getSourceFormattedAddress());
  const [destination, setDestination] = useState<string>(RequestBookingService.getDestinationFormattedAddress());
  const [sourceAutocomplete, setSourceAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
  const [destinationAutocomplete, setDestinationAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
  const [selectedSourceTerminal, setSelectedSourceTerminal] = useState<string>(AppContext.selectedSourceTerminal)
  const [selectedDestinationTerminal, setSelectedDestinationTerminal] = useState<string>(AppContext.selectedDestinationTerminal)
  const previousRouteRef = useRef<string | null>(null);
  const [srcTextFieldDisable, setSrcTextFieldDisable] = useState<boolean>()
  const [destTextFieldDisable, setDestTextFieldDisable] = useState<boolean>()
  const [isSourceMenuClicked, setIsSourceMenuClicked] = useState(false);
  const [isDestMenuClicked, setIsDestMenuClicked] = useState(false);


  useEffect(() => {

    if (previousRouteRef.current && previousRouteRef.current !== selectedRoute) {
      // refresh the source and destination when route change
      if (selectedRoute === "MUMBAI_TO_PUNE") {
        RequestBookingService.setSource(getTerminalT2Address());
        AppContext.selectedSourceTerminal = 'T2'
        AppContext.selectedDestinationTerminal = ''
        const updatedSource = getCompactAddress(RequestBookingService.getSourceFormattedAddress());
        setSource(updatedSource);
        RequestBookingService.setDestination(null);
        setIsSourceMenuClicked(false)
        setSrcTextFieldDisable(true)
        setDestTextFieldDisable(false)
        setDestination('');
      }
      if (selectedRoute === "PUNE_TO_MUMBAI" || selectedRoute === "RETURN_RIDE") {
        RequestBookingService.setSource(null);
        setSource('');
        RequestBookingService.setDestination(getTerminalT2Address());
        const updatedDestination = getCompactAddress(RequestBookingService.getDestinationFormattedAddress());
        setDestination(updatedDestination);
        AppContext.selectedSourceTerminal = ''
        AppContext.selectedDestinationTerminal = 'T2'
        setSrcTextFieldDisable(false)
        setDestTextFieldDisable(true)
        setIsDestMenuClicked(false)
      }

      setSelectedSourceTerminal(AppContext.selectedSourceTerminal);
      setSelectedDestinationTerminal(AppContext.selectedDestinationTerminal);
    }

    previousRouteRef.current = selectedRoute;
  }, [selectedRoute]);

  useEffect(() => {
    if (isLoaded && RequestBookingService.getRequestBooking().booking.fromAddress === "") {
      setIsDestMenuClicked(false)
      RequestBookingService.setDestination(getTerminalT2Address());
      const updatedDestination = getCompactAddress(RequestBookingService.getDestinationFormattedAddress());
      setDestination(updatedDestination);
      setSelectedDestinationTerminal("T2");
      setDestTextFieldDisable(true);
      AppContext.selectedDestinationTerminal = "T2"
    }
    else {
      const updatedSource = getCompactAddress(source);
      const updatedDestination = getCompactAddress(destination);

      setSource(updatedSource);
      setDestination(updatedDestination);

      if (updatedSource.includes("Terminal 1") || updatedSource.includes("Terminal 2")) {
        setSrcTextFieldDisable(true);
        setSelectedSourceTerminal(AppContext.selectedSourceTerminal);
      }

      if (updatedDestination.includes("Terminal 1") || updatedDestination.includes("Terminal 2")) {
        setDestTextFieldDisable(true);
        setSelectedDestinationTerminal(AppContext.selectedDestinationTerminal);
      }
    }

  }, [isLoaded])

  useEffect(() => {
    if (isAutoFill) {
      if (!RequestBookingService.getSource()) {
        setSource('')
      }
      if (!RequestBookingService.getDestination()) {
        setDestination('')
      }

    }

  }, [isAutoFill])



  const setRequestBookingSource = (place: google.maps.places.PlaceResult) => {
    if (place && place.formatted_address) {
      RequestBookingService.setSource(place);
      const address = place.formatted_address;
      if (address.includes("T1, Navpada,")) {
        setSelectedSourceTerminal("T1")
        AppContext.selectedSourceTerminal = "T1"
        setSrcTextFieldDisable(true)
      }
      if (address.includes("Terminal 2")) {
        setSelectedSourceTerminal("T2")
        AppContext.selectedSourceTerminal = "T2"
        setSrcTextFieldDisable(true)
      }
      setSource(getCompactAddress(address));
      setIsSourceMenuClicked(false)
      const sourceChangeEvent = {
        target: { name: "source", value: address },
      } as React.ChangeEvent<HTMLInputElement>;

      handleInputChange(sourceChangeEvent);

    } else {
      console.error("Invalid Source place result");
    }
  }

  const setRequestBookingDestination = (place: google.maps.places.PlaceResult) => {
    if (place && place.formatted_address) {
      RequestBookingService.setDestination(place)
      const address = place.formatted_address
      if (address.includes("T1, Navpada,")) {
        setSelectedDestinationTerminal("T1")
        AppContext.selectedDestinationTerminal = "T1"
        setDestTextFieldDisable(true)
      }
      if (address.includes("Terminal 2")) {
        setSelectedDestinationTerminal("T2")
        AppContext.selectedDestinationTerminal = "T2"
        setDestTextFieldDisable(true)
      }
      setDestination(getCompactAddress(address))
      setIsDestMenuClicked(false)
      const destinationChangeEvent = {
        target: { name: "destination", value: address },
      } as React.ChangeEvent<HTMLInputElement>;

      handleInputChange(destinationChangeEvent);

    } else {
      console.error("Invalid destination place result");
    }
  }

  const handleSourcePlaceChanged = async () => {
    if (!sourceAutocomplete) {
      console.error("sourceAutocomplete is not set yet.");
      return;
    }
    await handleAutocompletePlaceService(sourceAutocomplete, setRequestBookingSource);
  }

  const handleDestinationPlaceChanged = async () => {
    if (!destinationAutocomplete) {
      console.error("destinationAutocomplete is not set yet.");
      return;
    }
    await handleAutocompletePlaceService(destinationAutocomplete, setRequestBookingDestination);

  }
  const srcT1BtnPress = () => {
    setIsSourceMenuClicked(false)
    AppContext.selectedSourceTerminal = "T1";
    setSelectedSourceTerminal("T1");
    setRequestBookingSource(getTerminalT1Address())
    const src = RequestBookingService.getSourceFormattedAddress()
    setSource(getCompactAddress(src));
  }

  const srcT2BtnPress = () => {
    setIsSourceMenuClicked(false)
    AppContext.selectedSourceTerminal = "T2";
    setSelectedSourceTerminal("T2");
    setRequestBookingSource(getTerminalT2Address())
    const src = RequestBookingService.getSourceFormattedAddress()
    setSource(getCompactAddress(src));
  }
  const srcMenuIconPress = () => {
    setIsSourceMenuClicked(true)
    AppContext.selectedSourceTerminal = '';
    setSelectedSourceTerminal('')
    RequestBookingService.setSource(null);
    setSource('');
    setSrcTextFieldDisable(false)
  }
  const destT1BtnPress = () => {
    setIsDestMenuClicked(false)
    AppContext.selectedDestinationTerminal = "T1";
    setSelectedDestinationTerminal("T1");
    setRequestBookingDestination(getTerminalT1Address())
    const dest = RequestBookingService.getDestinationFormattedAddress()
    setDestination(getCompactAddress(dest));
  }
  const destT2BtnPress = () => {
    setIsDestMenuClicked(false)
    AppContext.selectedDestinationTerminal = "T2";
    setSelectedDestinationTerminal("T2");
    setRequestBookingDestination(getTerminalT2Address())
    const dest = RequestBookingService.getDestinationFormattedAddress()
    setDestination(getCompactAddress(dest));
  }
  const destMenuIconPress = () => {
    setIsDestMenuClicked(true)
    AppContext.selectedDestinationTerminal = '';
    setSelectedDestinationTerminal('')
    RequestBookingService.setDestination(null);
    setDestination('');
    setDestTextFieldDisable(false)
  }

  if (!isLoaded) return <div>Loading...</div>;

  const showTOptionsInSource = selectedRoute === "MUMBAI_TO_PUNE";
  const showTOptionsInDestination = selectedRoute === "PUNE_TO_MUMBAI" || selectedRoute === "RETURN_RIDE";

  return (
    <>
      <div className="col-lg-12 col-sm-12 col-md-12 mt-3">
        <Autocomplete
          onLoad={(autocomplete) => setSourceAutocomplete(autocomplete)}
          onPlaceChanged={handleSourcePlaceChanged}
        >
          <TextField
            name="source-address"
            label="Your Pickup Address"
            className="textField"
            value={source}
            onChange={(e) => setSource(e.target.value)}
            variant="outlined"
            autoComplete="off"
            disabled={srcTextFieldDisable}
            required
            fullWidth
            onFocus={(e) => { e.target.setAttribute("autocomplete", "off"); }}
            InputProps={{
              endAdornment: showTOptionsInSource ? (
                <div className="d-flex align-items-center gap-1 h-100">
                  <button type="button" className={`btn btn-sm terminalButton ${selectedSourceTerminal === "T1" ? "btn-success" : "btn-outline-secondary"}`} onClick={srcT1BtnPress} >
                    T1
                  </button>
                  <button type="button" className={`btn btn-sm terminalButton ${selectedSourceTerminal === "T2" ? "btn-success" : "btn-outline-secondary"}`} onClick={srcT2BtnPress} >
                    T2
                  </button>
                  <MenuIcon
                    data-testid="MenuIcon"
                    className={`MenuIcon ${isSourceMenuClicked ? "menuIconSelected" : ""}`}
                    onClick={srcMenuIconPress}
                  />
                </div>
              ) : null,
              inputProps: { autoComplete: "off" },
            }}
          />
        </Autocomplete>
      </div>

      <div className="col-lg-12 col-sm-12 col-md-12 mt-3">
        <Autocomplete
          onLoad={(autocomplete) => setDestinationAutocomplete(autocomplete)}
          onPlaceChanged={handleDestinationPlaceChanged}
        >
          <TextField
            name="destination-address"
            label="Your Drop Address"
            value={destination}
            onChange={(e) => setDestination(e.target.value)}
            variant="outlined"
            autoComplete="off"
            disabled={destTextFieldDisable}
            required
            fullWidth
            onFocus={(e) => { e.target.setAttribute("autocomplete", "off"); }}
            InputProps={{
              endAdornment: showTOptionsInDestination ? (
                <div className="d-flex align-items-center gap-1 h-100">
                  <button type="button" className={`btn btn-sm terminalButton ${selectedDestinationTerminal === "T1" ? "btn-success" : "btn-outline-secondary"}`} onClick={destT1BtnPress} >
                    T1
                  </button>
                  <button type="button" className={`btn btn-sm terminalButton ${selectedDestinationTerminal === "T2" ? "btn-success" : "btn-outline-secondary"}`} onClick={destT2BtnPress} >
                    T2
                  </button>
                  <MenuIcon
                    data-testid="MenuIcon"
                    className={`MenuIcon ${isDestMenuClicked ? "menuIconSelected" : ""}`}
                    onClick={destMenuIconPress}
                  />
                </div>
              ) : null,
              inputProps: { autoComplete: "off" },
            }}
          />
        </Autocomplete>
      </div>
    </>
  );
};

export default SelectSourceAndDestination;
